import Segment from "./segment";

export default Segment;
